<template>
    <div>
        <img
            :src="require(`.././../../assets/images/upgrade-now@2x.png`)"
            :srcset="`${require(`../../../assets/images/upgrade-now@1x.png`)} 1x, ${require(`../../../assets/images/upgrade-now@2x.png`)} 2x, ${require(`../../../assets/images/upgrade-now@3x.png`)} 3x, ${require(`../../../assets/images/upgrade-now@4x.png`)} 4x`"
        />

        <div class="modal-body d-flex gap-20">
            <div class="d-flex flex-column gap-10">
                <h2 class="modal-title">
                    {{ 'Not Enough Credits Left' | trans }}
                    <div class="icon-box">
                        <strong class="d-flex align-items-center">!</strong>
                        <div class="d-flex align-items-end"><CoinSVG /></div>
                    </div>
                </h2>
                <div class="modal-text">
                    <p>{{ "But don't worry, here are your options:" | trans }}</p>
                    <ul>
                        <li v-for="text in getUpgradeText" v-html="text"></li>
                    </ul>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import store from '../../../mixins/store.mixin';
import user from "../../../mixins/user.mixin";
import CoinSVG from '../../../../form/icons/CoinSVG.vue';

export default {
    name: 'UnregisteredCreditLimit',
    props: { 
        countdown: {
            type: String,
            default: ''
        },
        welcomeCredits: {
            type: Number,
            default: ''
        }
    },
    components: { CoinSVG },
    mixins: [store, user],
    data() {
        return {};
    },
    methods: {},
    computed: {
        getUpgradeText() {
            let text = [
                this.translate('<strong>Upgrade to Premium</strong> – Unlock instant access and exclusive features.'),
                this.translate(`Or <strong>Sign Up Now</strong> – Get ${this.welcomeCredits} Welcome Credits to continue testing.`),
                this.translate(`Or <strong>Come back in ${this.countdown}</strong> and get a fresh set of free credits!`),
            ]
            return text;
        }
    },
};
</script>
